'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arrayInsert;

var _arrayReplace = require('./arrayReplace');

var _arrayReplace2 = _interopRequireDefault(_arrayReplace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Insert a value into an array
 *
 * @param {Array} array The array to insert the items into
 * @param {number} index The index where to insert the values
 * @param {*} items The item(s) to insert
 * @returns {Array} The resulting array with the inserted `items`
 *
 * @example
 * const sourceArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
 * sourceArray, undefined, ['a', 'b', 'c']); // Returns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 'a', 'b', 'c']
 */
function arrayInsert(array, index, items) {
  return (0, _arrayReplace2.default)(array, index, 0, items);
}
//# sourceMappingURL=arrayInsert.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/arrayInsert.js
 ** module id = 183
 ** module chunks = 0 1
 **/